export enum PhoneType {
  Primary = 'Primary',
  Mobile = 'Mobile',
  Home = 'Home',
  Work = 'Work',
  Emergency = 'Emergency',
  Other = 'Other',
}
